<script>
import { $axios } from '@/modules/http/axios'
import Swal from 'sweetalert2'

export default {
  name: 'TasksFromCsv',
  data () {
    return {
      file: null,
      uploading: false
    }
  },
  methods: {
    async sendCsv () {
      this.uploading = true
      const formData = new FormData()
      formData.append('file', this.file)

      try {
        await $axios.post('TasksFromCsv', formData)
        await Swal.fire('Zaimportowano plik CSV', '', 'success')
        this.$refs.csvFile.value = null
      } catch (e) {
        let message = 'Nie udało się zaimportować pliku CSV'

        if (e.response.status === 400) {
          message = e.response?.data
        }

        await Swal.fire(message, '', 'error')
      } finally {
        this.uploading = false
      }
    },

    onFileChange (e) {
      const files = e.target.files || e.dataTransfer.files

      if (!files.length) {
        return
      }

      this.file = files[0]
    }
  }
}
</script>

<template>
  <div class="mt-5 mt-lg-0">
    <section class="fw-bold d-flex align-items-center">
      CSV:
      <input ref="csvFile" type="file" class="form-control ms-3" accept=".csv" @change="onFileChange"/>
      <div v-show="file">
        <button class="btn btn-success ms-2" @click="sendCsv" :disabled="uploading">
          Wyślij
        </button>
      </div>
    </section>
  </div>
</template>
